// extracted by mini-css-extract-plugin
export default {"total":"blockProducts-module__total--_30Z8","pale":"blockProducts-module__pale--HI4VV"};